import { FC } from 'react';
import { SelectField } from 'components/Forms/SelectField';
import { SwitchToggleField } from 'components/Forms/SwitchToggleField';
import { TextField } from 'components/Forms/TextField';
import { required } from 'helpers/utils';
import { FILTER_NAME_MAX_LENGTH, FILTER_TYPE_OPTIONS } from '../constants';
import { RenameWarning } from './RenameWarning';

type Props = {
  savedName?: string;
};

export const FilterSettingsSection: FC<Props> = ({ savedName }) => (
  <>
    <div className="row">
      <div className="col-md-12 padding0">
        <TextField
          label="Name *"
          name="filter_name"
          maxLength={FILTER_NAME_MAX_LENGTH}
          validate={required}
        />
        {savedName !== undefined && <RenameWarning originalName={savedName} />}
      </div>
    </div>
    <div className="row">
      <div className="col-md-4 padding0">
        <div className="form-input">
          <label htmlFor="filter_type">Type *</label>
          <SelectField name="filter_type" options={FILTER_TYPE_OPTIONS} validate={required} />
        </div>
      </div>
    </div>
    {savedName !== undefined && (
      <div className="row">
        <div className="col-md-4 padding0">
          <div className="form-input">
            <SwitchToggleField
              name="is_active"
              label="Status"
              onText="ACTIVE"
              offText="PAUSED"
              isWide
            />
          </div>
        </div>
      </div>
    )}
  </>
);
